import { z } from 'zod'

const groupRoiGoalSchema = z.object({ goal: z.number(), roi: z.number() })

const salesGoalSchema = z.object({
  goal: z.number().nullable(),
  sales: z.number(),
})

export { groupRoiGoalSchema, salesGoalSchema }
